<div class="l-main__contents">
    <div id="wrapper">
        <div class="c-text-1 h-margin-b24">{{ title }}</div>
        <div class="grid-area">
            <div class="loading" *ngIf="loading">
                <app-loading-circle></app-loading-circle>
            </div>
            <div class="list-header">
                <a class="goto-area" (click)="gotoArea()"> エリア選択に戻る </a>
            </div>
            <div class="update-wbs-item-wbs-item">
                <is-igx-mapping
                    #map
                    *ngIf="!loading"
                    [mappingData]="mappingData"
                    [paramData]="paramData"
                    [actions]="actions"
                    [mappingDataHub]="mappingDataHub"
                >
                </is-igx-mapping>
            </div>
        </div>
    </div>
</div>
<app-snackbar #snackbar [autoHide]="true"></app-snackbar>
<is-igx-hub #catalogHub [mappingData]="mappingDataCatalogHub" [paramData]="paramData" [actions]="catalogHubActions">
</is-igx-hub>

<is-igx-hub
    #selectedCatalogHub
    [mappingData]="mappingDataselectedCatalogHub"
    [paramData]="paramDataForSelectedCatalogHub"
    [actions]="selectedCatalogHubActions"
>
</is-igx-hub>

<is-igx-dialog-message
    #messageDialog
    [messageCd]="dialogMessageCd"
    (click)="dialogAction($event)"
></is-igx-dialog-message>
